import { render } from "./GiftItemSendAmountPopup.vue?vue&type=template&id=04337f43&scoped=true"
import script from "./GiftItemSendAmountPopup.vue?vue&type=script&lang=js"
export * from "./GiftItemSendAmountPopup.vue?vue&type=script&lang=js"

import "./GiftItemSendAmountPopup.vue?vue&type=style&index=0&id=04337f43&scoped=true&lang=css"

import exportComponent from "/home/viewchat/public_html/viewchat-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04337f43"]])

export default __exports__